import React, { useState } from 'react';
import styles from './Comments.module.scss';
import { AppAvatar } from '../../Avatar';
import { ImageSlider } from '../../../core/CustomImageSlider';
import { Button, ANTD_COMPONENTS } from 'tt-ui-lib/core';
import { MoreVIcon } from 'tt-ui-lib/icons';
import CommentsActions from './CommentsActions';

const { Dropdown } = ANTD_COMPONENTS;

const Reply = ({ item, user, index, onChangeComment }) => {
  const [open, setOpen] = useState(false);

  const handleReplyClose = () => {
    setOpen(false);
  };

  const parseReplyBody = (_body) => {
    let body = _body;
    let replyUsername = '';

    try {
      const bodyJSON = JSON.parse(_body);
      body = bodyJSON.body;
      replyUsername = bodyJSON.replyUsername;
    } catch (e) {
      body = _body;
      replyUsername = '';
    }

    if (replyUsername) {
      const indexInsertion = body.indexOf(replyUsername);
      const resultString =
        body.substring(0, indexInsertion) +
        body.substring(indexInsertion + replyUsername.length + 2);

      return (
        <div>
          <a
            href={`/dashboard/profile/${item.reply_user_id}`}
            style={{ color: '#18397A', fontWeight: 500 }}
          >
            {replyUsername}
          </a>
          , {resultString}
        </div>
      );
    }

    return <div>{body}</div>;
  };

  return (
    <div
      key={`${index + 1}`}
      className={styles.replyContainer}
      style={index === 0 ? { border: 'none' } : undefined}
    >
      <div>
        <AppAvatar
          nav={1}
          size="xs"
          userName={`${item.user.first_name} ${item.user.last_name}`}
          src={item.user.avatar}
        />
      </div>

      <div className={styles.commentContent}>
        <div
          className={styles.commentUserName}
        >{`${item.user.first_name} ${item.user.last_name}`}</div>

        <p className={styles.commentText}>{parseReplyBody(item.body)}</p>

        {item.files_image?.length > 0 && (
          <div className={styles.fileBox}>
            <div
              className={`${styles.fileBox} ${styles.imagesWrapper}`}
              onClick={(event) => event.stopPropagation()}
            >
              <ImageSlider array={item.files_image} />
            </div>
          </div>
        )}
      </div>

      <div className={styles.menuContainer}>
        <Dropdown
          open={open}
          onOpenChange={setOpen}
          // eslint-disable-next-line react/no-unstable-nested-components
          dropdownRender={() => (
            <div onClick={() => setOpen(false)} className={styles.dropdown}>
              <CommentsActions
                user={user}
                commentInstance={item}
                closeMenu={handleReplyClose}
                onDeleteComment={onChangeComment}
                isReply
              />
            </div>
          )}
          trigger="click"
        >
          <Button type="icon" className={styles.commentMenuButton}>
            <MoreVIcon style={{ width: 20, height: 20, flexShrink: 0, fontSize: 20 }} />
          </Button>
        </Dropdown>
      </div>
    </div>
  );
};

export default Reply;
